// extracted by mini-css-extract-plugin
export default {"wrapper":"SFnxw","image":"I4NlF","content":"wAPsn","header":"cNw9N","name":"HcHQ2","count":"EIoaO","footer":"e9MgM","discount":"LyKl1","link":"PP7Qp"};